










import { Component, Vue, Prop } from "vue-property-decorator";
import {
  TaskStatus as TaskStatusType,
  TaskStatusTypes
} from "@/models/task-status";

const statusLabel: Record<TaskStatusType, string> = {
  保留: "保留",
  未着工: "未着工",
  施工前: "施工前",
  施工中: "施工中",
  施工終了: "終了"
};

// TODO: 色を決める
const statusColor: Record<TaskStatusType, string> = {
  保留: "red",
  未着工: "gray",
  施工前: "black",
  施工中: "#0ba39a",
  施工終了: "gray"
};

@Component({})
export default class TaskStatus extends Vue {
  @Prop({ required: true, validator: v => TaskStatusTypes.includes(v) })
  type!: TaskStatusType;

  get color(): string {
    return statusColor[this.type];
  }

  get label(): string {
    return statusLabel[this.type];
  }
}
